import React, { useState, useEffect } from "react";
import DataTable from "../utilities/DataTable";
import MessageDetailsModal from "./MessageDetailsModal"; // Add this import

const RecentBulkMessages = ({ userStats }) => {
  const [loading, setLoading] = useState(true);
  const [bulkMessages, setBulkMessages] = useState([]);
  const [selectedMessage, setSelectedMessage] = useState(null); // Add state for selected message
  const [modalOpen, setModalOpen] = useState(false); // Add state for modal

  useEffect(() => {
    const fetchBulkMessages = async () => {
      setLoading(true);
      try {
        setTimeout(() => {
          setBulkMessages([...userStats.recent_bulk_messages]);
          setLoading(false);
        }, 800);
      } catch (error) {
        console.error("Error fetching bulk messages:", error);
        setLoading(false);
      }
    };
    fetchBulkMessages();
  }, [userStats]);

  // Define columns for the data table
  const columns = [
    {
      id: "sender_id",
      label: "Sender ID",
      minWidth: 120,
      align: "left",
    },
    {
      id: "sms_type",
      label: "Type",
      minWidth: 100,
      align: "left",
      render: (row) => (
        <div
          className={`px-3 py-1 font-bold capitalize rounded-full text-xs inline-block
          ${
            row.sms_type === "bulk"
              ? "bg-blue-100 text-blue-800"
              : row.sms_type === "quick"
              ? "bg-orange-100 text-orange-800"
              : row.sms_type === "voice"
              ? "bg-purple-100 text-purple-800"
              : row.sms_type === "email"
              ? "bg-orange-100 text-orange-800"
              : "bg-gray-100 text-gray-800"
          }`}
        >
          {row.sms_type}
        </div>
      ),
    },

    {
      id: "date",
      label: "Date",
      minWidth: 150,
      align: "left",
    },
    {
      id: "total_sent",
      label: "Total sent",
      minWidth: 100,
      align: "left",
    },
    {
      id: "status",
      label: "Status",
      minWidth: 120,
      align: "left",
      render: (row) => (
        <div
          className={`px-3 py-1 rounded-full text-xs font-medium inline-block
          ${
            row.status === "Completed"
              ? "bg-green-100 text-green-800"
              : row.status === "Failed"
              ? "bg-red-100 text-red-800"
              : "bg-yellow-100 text-yellow-800"
          }`}
        >
          {row.status}
        </div>
      ),
    },
  ];

  // Handle row click
  function handleRowClick(row) {
    //console.log("Row clicked:", row);
  }

  // Handle view action - opens the modal
  const handleViewMessage = (row) => {
    setSelectedMessage(row);
    setModalOpen(true);
  };

  // Handle modal close
  const handleCloseModal = () => {
    setModalOpen(false);
    setSelectedMessage(null);
  };

  // Custom actions configuration for DataTable
  const customActions = {
    onView: handleViewMessage,
    // onDownload: (row) => {
    //   //console.log("Download message:", row);
    //   // Implement download functionality here
    // },
    // onDetails: (row) => {
    //   //console.log("Show details:", row);
    //   // You can use this for additional actions if needed
    // },
  };

  return (
    <>
      <div className="p-6 mx-auto max-w-8xl bg-white rounded-xl shadow-md">
        <h2 className="mb-6 text-xl font-bold text-gray-800">
          Recent Messages
        </h2>

        <DataTable
          columns={columns}
          data={bulkMessages}
          loading={loading}
          searchable={true}
          searchFields={["sender_id", "status", "sms_type"]} // Added sms_type to search fields
          pagination={true}
          initialRowsPerPage={10}
          rowsPerPageOptions={[5, 10, 25, 50]}
          actions={true} // Set to true to show actions
          actionColumn={true} // Set to true to show action column
          onRowClick={handleRowClick}
          customActions={customActions} // Pass custom actions
        />
      </div>

      {/* Modal for viewing message details */}
      <MessageDetailsModal
        open={modalOpen}
        onClose={handleCloseModal}
        message={selectedMessage}
      />
    </>
  );
};

export default RecentBulkMessages;